module.exports = __webpack_public_path__ + "2d423222d8ebca0605850082f039813c.jpg";